import { render } from "./ProfileStats.vue?vue&type=template&id=acf787be&scoped=true"
import script from "./ProfileStats.vue?vue&type=script&lang=js"
export * from "./ProfileStats.vue?vue&type=script&lang=js"

import "./ProfileStats.vue?vue&type=style&index=0&id=acf787be&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acf787be"]])

export default __exports__